import { useTranslation } from "react-i18next";

import { useMode } from "@/shared/api";
import { Icon } from "@/shared/ui";

/**
 * Постоянная маркировка демо-режима (доработки §3.1: «на всех экранах
 * демо-режима должна быть постоянная маркировка DEMO / Виртуальные средства»).
 *
 * Живёт в каркасе, а не на страницах: §3.1 говорит «на всех экранах без
 * исключения», и плашка, которую каждый экран рисует сам, рано или поздно
 * окажется забытой на новом. Здесь её нельзя забыть — её негде забыть.
 *
 * `role="status"` и текст, а не только цвет: маркировка обязана дойти и до
 * человека, который цвет не различает, и до скринридера.
 */
export function DemoRibbon() {
  const { t } = useTranslation();
  const { isDemo } = useMode();

  if (!isDemo) return null;

  return (
    <div
      role="status"
      className="flex items-center justify-center gap-1.5 bg-status-warning px-3 py-1 text-text-inverse"
    >
      <Icon name="warningFill" size={14} />
      <span className="text-caption font-semibold tracking-wide uppercase">
        {t("demo.ribbon")}
      </span>
    </div>
  );
}
